import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.includes";
/**
 * Components / Templates: Recommended products.
 * ------------------------------------------------------------------------------
 * Handles the product & cart page recommended product cards.
 *
 *
 */

/**
* Returns recommended products card string template.
* @param {Object} item - Recommended product object data.
*/

export default (item => {
  /**
   * Returns main image template.
   * @param {Object} productItem - Recommended product object data.
   */
  function mainImage(productItem) {
    if (productItem.image === '') {
      return "\n        <img\n          class=\"bc-sf-filter-product-item-main-image\"\n          src=\"".concat(bcSfFilterMainConfig.general.no_image_url, "\"\n          alt=\"").concat(productItem.title, "\"\n        />\n      ");
    }

    return "\n        <img\n          class=\"bc-sf-filter-product-item-main-image\"\n          src=\"".concat(productItem.image, "\"\n          alt=\"").concat(productItem.title, "\"\n        />\n      ");
  }
  /**
     * Returns alt image template.
     * @param {Object} productItem - Recommended product object data.
     */


  function altImage(productItem) {
    if (productItem.altImage === '') {
      return '';
    }

    if (productItem.altImage.includes('swatch')) {
      return "\n        <img\n          class=\"bc-sf-filter-product-item-flip-image\"\n          src=\"".concat(productItem.image, "\"\n          alt=\"").concat(productItem.title, "\"\n        />\n      ");
    } else {
      return "\n        <img \n          class=\"bc-sf-filter-product-item-flip-image\"\n          src=\"".concat(productItem.altImage, "\"\n          alt=\"").concat(productItem.title, "\"\n        />\n      ");
    }
  }

  return "\n    <li\n      class=\"recommended-products__slide swiper-slide\"\n      js-carousel=\"cell\"\n      js-recommended-products=\"slide\"\n    >\n      <div class=\"bc-sf-filter-product-item bc-sf-filter-product-item-grid ".concat(item.altImage === '' ? '' : 'has-bc-swap-image', " bc-sf-filter-grid-width-3 bc-sf-filter-grid-width-mb-2 recommended-products__card\">\n        <div class=\"bc-sf-filter-product-item-inner\">\n          <div class=\"bc-sf-filter-product-item-image\">\n            <a\n              href=\"").concat(item.url, "\"\n              class=\"bc-sf-filter-product-item-image-link\"\n            >\n                ").concat(mainImage(item), "\n                ").concat(altImage(item), "\n            </a>\n          </div>\n          <div class=\"bc-sf-filter-product-bottom text-center\">\n            <a class=\"bc-sf-filter-product-item-title h6\">").concat(item.title, "</a>\n            <p class=\"bc-sf-filter-product-item-price body-1\">\n              <span class=\"bc-sf-filter-product-item-regular-price\">").concat(item.price, "</span>\n            </p>\n          </div>\n        </div>\n      </div>\n    </li>\n  ");
});